<template>
  <a-modal
    :visible="visible"
    @cancel="
      () => {
        visible = false
      }
    "
    :getContainer="() => document.getElementById('app')"
    :footer="null"
    :closable="true"
    width="1200px"
    class="modalWrap"
  >
    <div slot="title" class="titleWrap">
      公告通知
      <!-- <span v-if="isMore" @click="$router.push('/main/bulletin')">查看更多消息 ></span> -->
    </div>
    <div class="modal-body ql-editor">
      <div class="body-hd">
        <h3>{{ noticeData.title }}</h3>
        <p>时间: {{ noticeData.created_at }}</p>
      </div>
      <div class="modal-centent limitImgWrap" v-html="noticeData.desc"></div>
      <div class="footer-wrap">
        <span class="leftBtn" v-if="isMore" @click="$router.push('/main/bulletin')">更多公告 ></span>
        <span class="leftBtn" v-else></span>
        <div class="rightWrap" v-if="noticeList.length">
          <!-- <a :class="{ notBt: noticeIndex === 0 }" @click="turnFn('prev')"
            >上一篇: <span>{{ noticeList[noticeIndex === 0 ? 0 : noticeIndex - 1].title }}</span></a
          >
          <a :class="{ notBt: noticeIndex === noticeList.length - 1 }" @click="turnFn('next')"
            >下一篇:
            <span>{{
              noticeList[noticeIndex === noticeList.length - 1 ? noticeList.length - 1 : noticeIndex + 1].title
            }}</span></a
          > -->
          <!-- <a :class="{ notBt: noticeIndex === 0 }" @click="turnFn('prev')"
            >上一篇: <span>{{ noticeList[noticeIndex === 0 ? 0 : noticeIndex - 1].title }}</span></a
          >
          <a :class="{ notBt: noticeIndex === noticeList.length - 1 }" @click="turnFn('next')"
            >下一篇:
            <span>{{
              noticeList[noticeIndex === noticeList.length - 1 ? noticeList.length - 1 : noticeIndex + 1].title
            }}</span></a
          > -->
          <a :class="{ notBt: noticeIndex === 0 }" @click="turnFn('prev')"><a-icon type="left" />上一篇</a>
          <a :class="{ notBt: noticeIndex === noticeList.length - 1 }" @click="turnFn('next')"
            >下一篇<a-icon type="right"
          /></a>
        </div>
        <!-- <a-button class="rightBtn" @click="visible = false">关闭</a-button> -->
      </div>
    </div>
  </a-modal>
</template>

<script>
import './index.less'
import { viewNotice } from '@/api/bulletin/index'
export default {
  name: 'ViewModal',
  data() {
    return {
      visible: false,
      noticeIndex: 0,
      noticeData: {}
    }
  },
  components: {},
  computed: {},
  props: ['noticeList', 'isMore'],
  watch: {
    visible(value) {
      if (value) {
        viewNotice(this.noticeList[this.noticeIndex].id).then(res => {
          this.noticeData = res.data
        })
      }
    }
  },
  methods: {
    turnFn(str) {
      if (str === 'prev') {
        console.log('noticeList==', this.noticeList)
        console.log('noticeIndex==', this.noticeIndex)
        if (this.noticeIndex === 0) {
          return
        } else {
          this.noticeIndex--
        }
      } else {
        if (this.noticeIndex === this.noticeList.length - 1) {
          return
        } else {
          this.noticeIndex++
        }
      }
      viewNotice(this.noticeList[this.noticeIndex].id).then(res => {
        this.noticeData = res.data
      })
    }
  },
  mounted() {},
  created() {}
}
</script>

<style scoped lang="less"></style>
